/********************************************************************
 * Auto complete module
 *
 * Only show cities. If we also want to show courses we need
 * the get the bookable status before showing them in autocomplete.
 * Or find a way to make noticed that they do not have any
 * availability.
 *
 *
 * AfterXCharacters =>	- load 'auto complete courses'
 *						- show 'auto complete courses'
 *
 *	OnClick =>  - Select the option
 *				-  Fill CityId in FilterContext / Local Storage
 *
 ********************************************************************/
'use strict';

import { isElement, debounce, forEach } from 'lodash';
import { get as getPageOptions } from '../../01-helpers/utilities/options';
import containerManager from '../../01-helpers/filter-context/container-manager';

const moduleName = 'autocomplete',
	selectors = {
		base: `.js-${moduleName}`,
		input: `.js-${moduleName}-input`,
		list: `.js-${moduleName}-list`,
		listItem: `.js-${moduleName}-list-item`
	},
	optionNames = {
		nodeId: 'NodeId',
		page: 'Page'
	};

export default class AutoComplete {
	constructor(baseElement) {
		if (!isElement(baseElement)) {
			console.error(`Element has not been found.`);
			return false;
		}


		this._config(baseElement);
		this._setup();
	}

	/**********************************************************************/
	closeContainer() {
		this.list.innerHTML = '';
	}
	/**********************************************************************/

	/**
	 * Blur event handler
	 *
	 * @param {any} evt
	 */
	_onBlurHandler(evt) {
		this.closeContainer();
	}

	/**
	 * Handler for Click event on ListItem
	 *
	 * @param {any} evt - Click (Mouse) event
	 */
	_onItemClickHandler(evt) {
		const element = evt.currentTarget || evt.target,
			id = element.dataset.id,
			value = element.dataset.value,
			filterContextField = this.baseElement.getAttribute('data-selection-type'),
			filterContextId = element.dataset?.attr ? JSON.parse(element.dataset.attr)['data-selection-id'] : this.baseElement.getAttribute('data-selection-id');

		// set the value of chosen item in the input as searchTerm
		this.trigger.value = value;

		this.filterContext.update({
			[filterContextField]: value,
			[filterContextId]: id
		});

		this.input.dataset.autofill = true;
		// close the container after a selection is made
		this.closeContainer();
	}


	// WHAT TO DO WHEN SOMEBODY TYPES BUT NOT SELECT A PLACE?
	// 1. prevent submit of form
	// 2. if autocomplete shows, and enter is been hit, take the first option
	// 3. if no autocomplete shows, and enter is been hit, prevent submition.
	//	3a. Do we need to show a message?

	_onSubmitHandler(evt) {
		// if input is not autofilled from autocomplete, we block the submit
		if (this.input.dataset.autofill == 'false') {
			evt.preventDefault();

			if (this.list.childElementCount > 0) {
				this.input.dataset.autofill = true;
				this.list.children[0].querySelector('button').click();	

				this.baseElement.submit();
            }
		}
	}

	/**
	 * KeyUp event handler
	 * @param {any} evt
	 */
	_onKeyUpHandler(evt) {
		this.input.dataset.autofill = false;
	}

	/**
	 * Set click event handler on listItems in the List
	 * @param {any} list - list that contains the listItems
	 */
	_setClickEvent(list) {
		const listItems = list.querySelectorAll(selectors.listItem);

		forEach(listItems, listItem => {
			listItem.addEventListener('click', (event) => {
				this._onItemClickHandler(event);
			});
		});
	}


	/**
	 * Bind event handling
	 **/
	_bindEvents() {
		// onfocus event handler
		this.input.addEventListener('blur', debounce(this._onBlurHandler.bind(this), 500, { 'leading': false, 'trailing': true }), true);

		this.baseElement.addEventListener('submit', this._onSubmitHandler.bind(this));
		// onkeydown event handler
		this.input.addEventListener('keydown', debounce(this._onKeyUpHandler.bind(this), 300, { 'leading': false, 'trailing': true }), true);
	}

	_config(baseElement) {
		this.baseElement = baseElement;
		this.input = this.baseElement.querySelector(selectors.input);
		this.list = this.baseElement.querySelector(selectors.list);
		this.filterContext = containerManager.getContainer();
		this.NodeId = getPageOptions(optionNames.nodeId);
		this.Page = parseInt(getPageOptions(optionNames.page)) || 1;
	}

	_setup() {
		this._bindEvents();
    }
}